import styled from 'styled-components';
import theme from '../../styles/theme';

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TabsHeader = styled.div`
  display: flex;
  border-bottom: 1px solid ${theme.colors.neutral.border.weak};
  margin-bottom: ${theme.spacing['spacing-4']};
`;

export const TabButton = styled.button<{ isActive: boolean }>`
  padding: ${theme.spacing['spacing-2']} ${theme.spacing['spacing-3']};
  background: none;
  border: none;
  border-bottom: 3px solid
    ${({ isActive }) =>
      isActive ? theme.colors.primary.bg.regular : 'transparent'};
  color: ${({ isActive }) =>
    isActive
      ? theme.colors.neutral.text.strong
      : theme.colors.neutral.text.weak};
  cursor: pointer;
  ${theme.textStyles['text-preset-7']()}
  transition: all 0.2s ease-in-out;
  &:focus {
    outline: none;
  }
  &:disabled {
    color: ${theme.colors.neutral.text.weak};
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const TabContent = styled.div`
  width: 100%;
`;
